export default __webpack_public_path__ + "static/media/displaypict.a0320c93.png";